import { Component } from '@angular/core';

interface Feature {
  text: string;
}

@Component({
  selector: 'app-feature-section-alt-redesign',
  templateUrl: './feature-section-alt-redesign.component.html',
  styleUrls: ['./feature-section-alt-redesign.component.scss']
})
export class FeatureSectionAltRedesignComponent {

  features: Feature[] = [
    { text: 'PATENTED PREDICTIVE AI AGENTS' },
    { text: 'HANDS-FREE AI ASSISTANCE' },
    { text: 'REAL-TIME ALERTS FOR CARE TEAMS' },
    { text: 'COLLABORATION PLATFORM' },
    { text: 'WORKS WITH EXISTING WEARABLES AND MEDICAL DEVICES' },
    { text: 'SECURE AND COMPLIANT BY DESIGN' }
  ];

  trackByText(index: number, feature: Feature): string {
    return feature.text;
  }

}